// Core
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Dashboard
import { AppDashboardComponent } from '../../dashboard/components/dashboard/dashboard.component';

// Modules
import { ReportModule } from 'app/report/modules/report.module';

// Reports
import { ReportComponent } from '../../report/components/report/report.component';
import { ReportViewComponent } from '../../report/components/view/report-view.component';
import { ReportListComponent } from '../../report/components/report-list/report-list.component';
import { ReportNewComponent } from '../../report/components/create/report-new.component';
import { ReportDownloadComponent } from '../../report/components/download/report-download.component';
import { ReportArchiveComponent } from '../../report/components/archive-list/report-archive-list.component';
import { SaveReportComponent } from '../../report/components/save/report-save.component';
import { ReportSummaryComponent } from '../../report/components/summary/report-summary.component';
import { ReportStatusComponent } from '../../report/components/status/report-status.component';

// Adjustments
import { SectorAdjustmentsComponent } from '../../report/adjustments/components/sector-adjustments.component';
import { VehicleAdjustmentsComponent } from '../../report/adjustments/components/vehicle-adjustments.component';
import { AdjustmentComponent } from '../../report/adjustments/components/adjustment.component';
import { SpecificationAdjustmentsComponent } from '../../report/adjustments/components/specification-adjustments.component';

// Settings
import { SettingsComponent } from '../../settings/components/settings.component';
import { ReportSettingsComponent } from '../../settings/components/settings-report-options.component';
import { OutputSettingsComponent } from '../../settings/components/settings-output-options.component';
import { AdjustmentSettingsComponent } from '../../settings/components/settings-adjustments.component';

// Auth
import { AuthGuardService } from '../../auth/services/auth-guard.service';
import { UnauthorisedComponent } from '../../auth/components/login-unauthorised.component';
import { NoAccessComponent } from '../../shared/components/no-access.component';

// Routing
import { EmptyComponent } from '../../shared/components/empty.component';
import { RedirectComponent } from '../components/redirect.component';
import { RoutingService } from '../services/routing.service';
import { PrivacyNoticeComponent } from '../../shared/components/privacy-notice/privacy-notice.component';

const settingsChildRoutes: Routes = [
    { path: '', redirectTo: 'report', pathMatch: 'full' },
    { path: 'report', component: ReportSettingsComponent, data: { breadcrumb: 'Report Settings'}  },
    { path: 'output', component: OutputSettingsComponent, data: { breadcrumb: 'Output Settings'}  },
    { path: 'adjust', component: AdjustmentSettingsComponent, data: { breadcrumb: 'Adjustment Settings'}  }
];

const reportAdjustChildRoutes: Routes = [
    { path: '', redirectTo: 'sectors', pathMatch: 'full'},
    { path: 'sectors', component: SectorAdjustmentsComponent , data: { breadcrumb: 'Sector Adjustments'} },
    { path: 'spec', component: SpecificationAdjustmentsComponent, data: { breadcrumb: 'Specification Adjustments'}  },
    { path: 'vehicles', component: VehicleAdjustmentsComponent, data: { breadcrumb: 'Vehicle Adjustments'}  }
];

const reportChildRoutes: Routes = [
    { path: '', redirectTo: 'create', pathMatch: 'full' },
    { path: 'create', component: ReportNewComponent, data: { breadcrumb: 'New Report'}  },
    { path: 'adjust', component: AdjustmentComponent, children: reportAdjustChildRoutes, data: { breadcrumb: 'Adjustments'}  },
    { path: 'save', component: SaveReportComponent, data: { breadcrumb: 'Save Report'}  },
    { path: 'summary/:id', component: ReportSummaryComponent, data: { breadcrumb: 'Report Summary'}  },
    { path: 'download', component: ReportDownloadComponent, canActivate: [AuthGuardService], data: { breadcrumb: 'Download Report'}  },
    { path: 'status', component: ReportStatusComponent, data: { breadcrumb: 'Report Status'}  }
];

const reportsChildRoutes: Routes = [
    { path: '', redirectTo: 'active', pathMatch: 'full' },
    { path: 'active', component: ReportListComponent, data: { breadcrumb: 'Active Reports'} },
    { path: 'archive', component: ReportArchiveComponent, data: { breadcrumb: 'Archived Reports'} }
];

const parentRoutes: Routes = [
    { path: '', redirectTo: '/dashboard', pathMatch: 'full', canActivate: [AuthGuardService] },
    { path: 'dashboard', component: AppDashboardComponent, canActivate: [AuthGuardService] },
    { path: 'reports', component: ReportComponent, children: reportsChildRoutes,
        canActivate: [AuthGuardService], data: { breadcrumb: 'Reports'}},
    { path: 'report', component: ReportViewComponent, children: reportChildRoutes,
        canActivate: [AuthGuardService], data: { breadcrumb: 'Report'}},
    { path: 'download/:id', component: ReportDownloadComponent, canActivate: [AuthGuardService], data: { breadcrumb: 'Download Report'}  },
    { path: 'editorial', component: RedirectComponent, pathMatch: 'full', data: { url: 'editorial' } },
    { path: 'settings', component: SettingsComponent, children: settingsChildRoutes,
        canActivate: [AuthGuardService], data: { breadcrumb: 'Settings'}},
    { path: 'help', component: RedirectComponent, pathMatch: 'full', data: {url: 'help' } },
    { path: 'unauthorised', component: UnauthorisedComponent },
    { path: 'noaccess', component: NoAccessComponent },
    { path: 'privacynotice', component: PrivacyNoticeComponent, data: { breadcrumb: 'Privacy Notice'} }
];

@NgModule({
    declarations: [RedirectComponent],
    imports: [
        RouterModule.forRoot(parentRoutes)
    ],
    exports: [RouterModule],
    providers: [RoutingService]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/routing/modules/routing.module.ts